/** @jsxImportSource @emotion/react */
import React from 'react';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { di, TitleWrap } from 'components/layouts/Dialog';
import { ImgBox } from 'components/layouts/Board';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  close: () => void;
};

/**
 * FA 셋업 프로젝트요약 > Dashboard 지표정의서 팝업
 * @param props
 * @constructor
 */
export const SetupIdDefinitionPopup = ({ open, close }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} css={di.dialog} fullWidth className="lg" maxWidth={false}>
      <TitleWrap>
        <h2>{t('setup.label.지표정의서', '지표정의서')}</h2>
        <Button onClick={() => close()} disableRipple />
      </TitleWrap>
      <DialogContent>
        <ImgBox>
          <img src="/assets/SetupIdDefinition.png"></img>
        </ImgBox>
      </DialogContent>
    </Dialog>
  );
};
